<template>
<div class="s4s-page" style="padding:0;">
  <!-- 招行付款form请求 start -->
  <form ref="cmbform" action="https://netpay.cmbchina.com/netpayment/BaseHttp.dll?MB_APPPay" method="post" >
    <input ref="jsonRequestData" id="jsonRequestData" type="hidden" name="jsonRequestData" v-model="jsonRequestData" />
    <input ref="child" type="hidden" name="charset" value='utf-8' />
  </form>
  <!-- 招行付款form请求 end -->
  <div class="s4s-tab">
      <div v-for="(item, index) in tabs" :key="index"
      :class="selIndex == item.status ? 's4s-tab-cur s4s-tab-item ' : 's4s-tab-item '"
      @click="selTab(item.status)">
      {{ item.name }}
        <span
          v-if="item.status == 0 && staticData.UnpaySum && showUnpaySum "
          class="s4s-tab-num">{{ staticData.UnpaySum }}</span>
        <span
          v-if="item.status == 3 && staticData.HandleSum && showHandleSum "
          class="s4s-tab-num">{{ staticData.HandleSum }}</span>
      </div>
  </div>
  <div class="s4s-order-body" v-if=" lists.length > 0 " >
    <div  v-for="(item, index) in lists" :key="index"  class="s4s-cell" >
        <div>
        <div @click="gotoDetail(item)"
          style=" padding-bottom:15px;">
          <div class="s4s-cell-hd">
            <span class="s4s-cell-hd-time">{{ item.SwiftNum || '-' }}</span>
            <span v-if="item.Status == 0" class="s4s-cell-status"
            style="color: #fd2900;border:none;font-size:12px;">
              剩余支付时间 {{item.Time || 30}} 分钟
            </span>
            <span v-if="item.Status == 3" class="s4s-cell-status"
            style="color: #3A82FF;border-color:#3A82FF;">处理中</span>
            <span v-if="item.Status == 7" class="s4s-cell-status"
            style="color: #3CB034;border-color:#3CB034;">已完成</span>
            <span v-if="item.Status == 5" class="s4s-cell-status"
            style="color: #ffaf30;border-color:#ffaf30;">已退款</span>
            <span v-if="item.Status == 2" class="s4s-cell-status"
            style="color: #AAAAAA;border-color:#AAAAAA;">已取消</span>
            <span v-if="item.Status == 6" class="s4s-cell-status"
            style="color: #AAAAAA;border-color:#AAAAAA;">退款中</span>
          </div>
          <div class="s4s-cell-bd">
            <span class="s4s-cell-tit">车牌号码：</span>
            <span class="s4s-cell-txt">{{ item.car_no || '-' }}</span>
          </div>
          <div class="s4s-cell-bd">
            <span class="s4s-cell-tit">认罚时间：</span>
            <span class="s4s-cell-txt">{{ item.btr_time || '-' }}</span>
          </div>
          <div class="s4s-cell-bd">
            <span class="s4s-cell-tit">合计金额：</span>
            <span class="s4s-cell-txt"  style="color:#3A82FF;">￥{{ ((item.TotalPrice || 0) / 100).toFixed(2) }}{{item.Urge ?'（加急）':''}} {{item.RePayStatus===2 ? ('补缴：￥'+ item.RePayFee) : ''}}</span>
          </div>
          <div class="s4s-cell-bd">
            <span class="s4s-cell-tit">创建时间：</span>
            <span class="s4s-cell-txt">{{ item.CreateTime }}</span>
          </div>
          <div v-if="item.canReUpload || item.canRePay" class="s4s-cell-bd">
            <span class="s4s-cell-tit">订单状态：</span>
            <span v-if="item.canRePay" class="s4s-cell-txt red">待补缴</span>
            <span v-else-if="item.canReUpload" class="s4s-cell-txt red">待补图</span>
          </div>
          <div  class="s4s-cell-bd" v-if="item.Status == 3">
            <div class="s4s-cell-tit"  style="color:#24252d;" >此罚单预计 <span style="margin:4px;color:#3A82FF;" >{{item.CompleteTime}}</span> 处理完成</div>
          </div>
        </div>
        <!-- TODO 支付 -->
        <div class="s4s-cell-fd" v-if="item.Status == 0">
          <span @click="cancelOrder(item.id)" >取消订单</span>
          <!-- <span @click="bindPay">立即支付</span> -->
          <span v-if="showWeixinPay"
            @click="bindPay(item,'wechat_web')" class="wxpay-btn">
            微信支付
          </span>
          <span v-if="['cmbchange','cmbapp','abchina', 'unionpay'].indexOf(advertisingShow.channel) == -1"
            @click="bindPay(item,'alipay')" class='alipay-btn'>
            支付宝支付
          </span>
          <span v-if="['abchina'].indexOf(advertisingShow.channel) !== -1"
            @click="bindPay(item,'abchina')" class='alipay-btn'>
            立即支付
          </span>
          <span v-if="['unionpay'].indexOf(advertisingShow.channel) !== -1"
            @click="bindPay(item,'unionpay')" class='alipay-btn'>
            立即支付
          </span>
          <span v-if="['cmbchange','cmbapp'].indexOf(advertisingShow.channel) !== -1" class="alipay-btn"
            @click="bindPay(item,'cmbchina2')"
            :style="{backgroundImage:advertisingShow.backgroundImage}">
              立即支付
          </span>
        </div>
        <!-- <div class="s4s-cell-fd"> -->
        <div class="s4s-cell-fd" v-if="item.Status == 7 || item.Status == 3">
          <a href="tel://0571-26281166" >申请退款</a>
          <span class="opt-btn " v-if="item.canRePay" style="margin-left:14rpx;" data-mode="repay" @click="handleModify(item,'repay')" >立即补缴</span>
          <span class="opt-btn " v-if="item.canReUpload" style="margin-left:14rpx;" data-mode="reupload" @click="handleModify(item,'reupload')" >重新上传罚单</span>
          <span class="opt-btn " v-if="item.UrgeShow" data-mode="urge" style="margin-left:14rpx;" @click="handleModify(item,'urge')" >申请加急</span>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="s4s-empty">
    <img src="https://mys4s.cn/h5/img_vio/empty_list.png" mode="scaleToFill" />
    <span>暂无订单</span>
  </div>
  <div class="s4s-mask-pay" @click="closePay" v-if="showpay">
    <p>请扫码付款</p>
    <img :src="paysrc" />
  </div>
  <a href="" ref="newWeborder" style="background: transparent;border: none"></a>
  <Confirm
    :show-dialog="showDialog"
    :ok-text="'确定'"
    :cancel-text="'取消'"
    :title="'确定取消此笔订单？'"
    v-on:confirm="confirmFn"
    v-on:cancel="showDialog = false"
  />
     <!-- 付款返回 start -->
     <Confirm
    :show-dialog="showPayEnd"
    :ok-text="'支付完成'"
    :cancel-text="'重新支付'"
    :title="'支付确认'"
    :content="'若未完成支付，请点击重新支付。'"
    v-on:confirm="gotoSuccess"
    v-on:cancel="showPayEnd = false"
  />
    <!-- 付款返回 end -->
  </div>
</template>

<script>
// @ is an alias to /src
import Confirm from '@/components/Confirm.vue';
import advertisingShow from './../utils/advertising';

export default {
  name: 'order',
  components: {
    Confirm,
  },
  data() {
    return {
      showWeixinPay: true,
      advertisingShow: advertisingShow(),
      // 需要挪至store
      staticData: {},
      tabs: [
        { name: '全部', status: -1 },
        { name: '待付款', status: 0 },
        { name: '处理中', status: 3 },
        { name: '已完成', status: 7 },
        { name: '已取消', status: 2 },
      ],
      selIndex: -1,
      lists: [],
      user: null,
      showUnpaySum: true,
      showHandleSum: true,
      showDialog: false,
      cancelId: 0,

      system: {},
      timer: null,
      out_trade_no: '',
      paysrc: '',
      showpay: false,

      showPayEnd: false,
      orderItem: {},
      jsonRequestData: '',
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo || this.$store.getters.userInfo;
    },
  },
  mounted() {
    if (this.advertisingShow.channel === 'unionpay' || window.localStorage.getItem('viochannel') === 'unionpay') {
      upsdk.setTitleStyle({
        // 可选，导航栏(含状态栏)背景色及透明度。16进制，前2位(8F)透明度，后六位(FFFFFF)颜色，仅对当前页有效，其余页还是申请配置的导航默认颜色
        navBackgroundColor:'0x8FFFFFFF',
        appletStyle: 'black', //可选，black-黑色主题，white-白色主题
        backBtnVisible: '1', // 可选，左侧返回按钮是否显示。'0'不显示，'1'显示，不传或空则默认显示
        appletTitleBarVisible: '1',// 可选，标题栏是否显示。'0'不显示，'1'显示，默认显示
      })
      upsdk.setNavigationBarTitle({
        title: '我的订单'
      });
    }
    const nowChannel = this.advertisingShow.channel;
    const notShowWeixinPay = ['xcarillegal', 'xcarticket', 'cmbchange', 'cmbapp', 'abchina', 'unionpay']; //   这个数组里的channel 不展示  微信支付
    if (notShowWeixinPay.indexOf(nowChannel) !== -1) {
      this.showWeixinPay = false;
    }
    if (this.advertisingShow.channel === 'cmbapp' || this.advertisingShow.channel === 'cmbchange') {
      this.payType = 'cmbchina2';
      this.access_token = this.$store.getters.token;
      this.channel = window.localStorage.viochannel;
      this.t = (new Date()).getTime();
    }else if (this.advertisingShow.channel === 'abchina' || window.localStorage.getItem('viochannel') === 'abchina'){
      this.payType = 'abchina';
    }else if (this.advertisingShow.channel === 'unionpay' || window.localStorage.getItem('viochannel') === 'unionpay') {
      this.payType = 'unionpay';
    }
    if (!this.userInfo) {
      this.$router.replace({
        path: '/login',
        query: {
          redirect: '/user',
        },
      });
    } else {
      // 需要挪至store
      this.getOrder(this.selIndex);
      this.getOrderStatic();
    }

    // const p = navigator.platform;
    // this.system.win = p.indexOf('Win') >= 0;
    // this.system.mac = p.indexOf('Mac') >= 0;
    // this.system.x11 = (p === 'X11') || (p.indexOf('Linux') >= 0);
    this.system.win = false;
    this.system.mac = false;
    this.system.x11 = false;
    const ua = navigator.userAgent.toLowerCase();
    this.system.isWeixin = ua.indexOf('micromessenger') !== -1;
  },
  methods: {
    gotoSuccess() {
      const item = this.orderItem;
      if (item.ViolationId && !item.writ_notice_num) {
        this.$router.push({
          path: '/success1',
          query: {
            orderId: item.id,
          },
        });
      } else if (!item.ViolationId && item.writ_notice_num) {
        this.$router.push({
          path: '/success2',
          query: {
            orderId: this.orderId,
          },
        });
      }
    },
    confirmFn() {
      const param = {
        order_id: this.cancelId,
      };
        // v3/violation/order/cancel v2/car/cancel_vio_order
      this.$request('v3/violation/order/cancel', param).then((xhr, res) => {
        this.showDialog = false;
        this.cancelId = 0;
        if (res.code === 0 && res.data === 'ok') {
          this.$showToast({
            icon: 'none',
            title: '取消成功',
          });
          this.getOrder(this.selIndex);
        } else {
          this.$showToast({
            icon: 'none',
            title: res.msg,
          });
        }
      }).catch((e) => {
        this.showDialog = false;
        console.log(e);
      });
    },
    // 获取订单状态
    getOrderStatic() {
      this.$request('v3/violation/order/static').then((res) => {
        if (res.code === 0) {
          this.staticData = res.data;
        }
      });
    },
    // 选择Tab
    selTab(index) {
      if (index === 0) {
        this.showUnpaySum = false;
      } if (index === 3) {
        this.showHandleSum = false;
      }
      this.getOrder(index);
      this.selIndex = index;
    },
    closePay() {
      this.showpay = false;
      clearInterval(this.timer);
    },
    getPayStatus() {
      const self = this;
      this.$request('/v3/violation/order/poll', {
        order_id: this.out_trade_no,
      }).then((xhr, res) => {
        if (res.code === 0 && res.data === 1) {
          self.showpay = false;
          clearInterval(self.timer);
          self.$router.push({
            path: '/success',
          });
        }
      });
    },
    // 在线支付
    bindPay(item, payType) {
      const self = this;
      const param = {
        order_id: item.id,
      };
      if (payType === 'wechat_web') {
        param.pay_method = 'wechat_h5';
        param.client_ip = '';
        const city = window.returnCitySN;
        if (city) {
          param.client_ip = city.cip;
        }
        const ua = navigator.userAgent.toLowerCase();
        // if (!self.system.win && !self.system.mac && !self.system.xll) {
        if (ua.match(/MicroMessenger/i) === 'micromessenger') {
          param.pay_method = 'wechat_app';
        } else {
          param.pay_method = 'wechat_h5';
        }
        // param.pay_method = 'wechat_h5';
        // }
      }
      if (this.payType === 'abchina') {
        param.pay_method = 'abchina';
        console.log('--------n行支付');
        this.$request('v3/violation/web/order/repay', param).then((xhr, res) => {
          if (res.code > 0) {
            self.$showToast({
              icon: 'none',
              title: res.msg,
            });
            return;
          }
          if (res.data && res.data.qr_code) {
            if(window.navigator.userAgent.indexOf('Bankabc/Portal') != -1) {//1. 判断是否在n行app新容器
              let qr_code = res.data.qr_code.replace('|','*')
              qr_code = qr_code.split('*')
              let tokenId = qr_code[1]
              let webviewURL = qr_code[2]
              AlipayJSBridge.call('startApp',{
                appId: '30603024', // 固定值
                param:{
                  type: "3", //   3： zy内H5页面，
                  tokenId: tokenId,  //商户传过来的tokenId
                  paySystem: "",       //商户传过来的paySystem, 没有则传空字符串
                  payType: "1111",         //商户传过来的payType，没有则传'1111'
                  webviewURL: webviewURL,      //商户传过来的回跳地址
                  startMultApp: 'YES', // 同一个H5容器如果需要多次调起快E付
                  showProgress: 'NO',
                  backBehavior: 'back'
                },
              },function(result){
              });
            }else{
              window.location.href = res.data.qr_code;
            }
          }
        });
        return;
      }
      if (this.payType === 'unionpay') {
        param.pay_method = 'unionpay';

        this.$request('v3/violation/web/order/repay', param).then((xhr, res) => {
          if (res.code > 0) {
            self.$showToast({
              icon: 'none',
              title: res.msg,
            });
            return;
          }

          if (res.data && res.data.tn) {
            upsdk.pay({
              tn: res.data.tn,
              success: () => {
                window.location.href = "https://mys4s.cn/static/vio/index.html#/ticket?channel=unionpay"
              },
              fail: (e) => {

              }
            })
          }
        });
        return;
      }
      if (this.payType === 'cmbchina2' || payType === 'cmbchina2') {
        // window.location.href = `https://mys4s.cn/grey/v3/violation/web/order/repay?pay_method=cmbchina2&order_id=${param.order_id
        // }&access_token=${this.access_token}&channel=${this.channel}&t=${this.t}`;
        const cmbform = this.$refs.cmbform;
        param.pay_method = 'cmbchina2';
        this.$request('v3/violation/web/order/repay', param).then((xhr, res) => {
          if (res.code === 0) {
            document.getElementById('jsonRequestData').value = res.data;
            cmbform.submit();
          }
        });
        return;
      }
      // v2 参数是oid   v3是order_id
      // v2/car/vio_pay_order
      this.$request('v3/violation/web/order/repay', param).then((xhr, res) => {
        if (res.code === 20022 || (res.code >= 40000 && res.code < 50000)) {
          self.$router.replace({
            path: '/login',
            query: {
              redirect: '/order',
            },
          });
          return;
        }
        if (res.code > 0) {
          self.$showToast({
            icon: 'none',
            title: res.msg,
          });
        }
        if (res.code === 0) {
          let com = this.system.win || this.system.mac || this.system.xll;
          com = false;
          if (com) {
            console.log('电脑');
            // 如果是电脑跳转到
            self.paysrc = payType === 'wechat_web' ? res.data.CodeImg : res.data.qr_code_img;
            self.out_trade_no = res.data.out_trade_no;
            self.showpay = true;
            self.timer = setInterval(self.getPayStatus, 1000);
            self.selectPrice = item.TotalPrice;
          } else if (payType === 'wechat_web') {
            const ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) === 'micromessenger') {
              const { data } = res;
              if (typeof WeixinJSBridge === 'undefined') {
                this.$showToast({ title: '支付失败,请稍后再试' });
              } else {
                WeixinJSBridge.invoke(//eslint-disable-line
                  'getBrandWCPayRequest', {
                    appId: data.appId, // 公众号名称，由商户传入
                    timeStamp: data.timeStamp || data.timestamp, // 时间戳，自1970年以来的秒数
                    nonceStr: data.nonceStr, // 随机串
                    package: data.package,
                    signType: data.signType, // 微信签名方式：
                    paySign: data.paySign, // 微信签名
                  },
                  (ress) => {
                    self.$router.replace({
                      path: '/order',
                    });
                    // if (self.user.Tel == '18072755357' || self.user.Tel == '13372576987') {
                    //   window.alert(JSON.stringify(ress));
                    //   window.alert(ress.err_msg);
                    // }
                    if (ress.err_msg === 'get_brand_wcpay_request:ok') {
                      self.$router.replace({
                        path: '/order',
                      });
                      self.$router.replace({
                        path: '/success',
                      });
                    } // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
                  },
                );
              }
            } else if (res.data && res.data.MwebUrl) {
              self.$refs.newWeborder.href = res.data.MwebUrl;
              self.$refs.newWeborder.click();
            }
            // window.location.href = res.data.MwebUrl
          } else {
            self.$refs.newWeborder.href = res.data.qr_code;
            self.$refs.newWeborder.click();
            // window.open(res.data.qr_code);
            // this.orderItem = item;
            // this.showPayEnd = true;
            // this.gotoSuccess();
          }
        } else {
          this.showPayEnd = false;
          this.orderItem = {};
          this.$showToast({
            title: res.msg,
          });
        }
        // if (item.ViolationId && !item.writ_notice_num) {
        //   this.$navigateTo({
        //     url: `../success/success?orderId=${item.id}`,
        //   });
        // } else if (!item.ViolationId && item.writ_notice_num) {
        //   this.$navigateTo({
        //     url: `../success2/success2?orderId=${item.id}`,
        //   });
        // }
      }).catch((e) => {
        this.showPayEnd = false;
        this.orderItem = {};

        console.log(e);
      });
    },
    // 取消订单
    cancelOrder(id) {
      this.showDialog = true;
      this.cancelId = id;
    },
    gotoDetail(item) {
      if (item.ViolationId && !item.writ_notice_num) {
        this.$router.push({
          path: `/detail1?orderId=${item.id}`,
        });
      } else if (!item.ViolationId && item.writ_notice_num) {
        this.$router.push({
          path: `/detail2?orderId=${item.id}`,
        });
      }
    },
    // 获取订单
    getOrder(status) {
      this.lists = [];
      const param = {
        status,
      };
      const nowhours = new Date().getHours();
      this.$request('v3/violation/order/list', param).then((xhr, res) => {
        if (res.code === 0 && res.data) {
          const list = res.data.map((item) => {
            if (item.Status === 0 || item.Status === 11) {
              item.Time = parseInt(((new Date(item.CreateTime.replace(new RegExp('-', 'g'), '/')).valueOf() + 0.5 * 60 * 60 * 1000) - new Date().valueOf()) / 1000 / 60);//eslint-disable-line
            }
            // item.Status = 3
            if (item.Status == 3) {
              try {
                const hours = new Date(item.CreateTime.replace(new RegExp('-', 'g'), '/')).getHours();
                const time = new Date(item.CreateTime.replace(new RegExp('-', 'g'), '/'));

                if (item.ViolationId && !item.writ_notice_num) {
                  if (hours >= 0 && hours <= 8) {
                    time.setDate(time.getDate() + 1);
                  } else if (hours > 8 && hours < 23) {
                    time.setDate(time.getDate() + 2);
                  }
                } else if (!item.ViolationId && item.writ_notice_num) {
                  if (hours >= 0 && hours <= 12) {
                  } else if (hours > 12 && hours < 23) {
                    time.setDate(time.getDate() + 1);
                  }
                }
                item.CompleteTime = this.getNowFormatDate(time);
                if (((new Date(item.CompleteTime.replace(new RegExp('-', 'g'), '/')).valueOf()) < (new Date()).valueOf()) || item.Urge) {
                  item.CompleteTime = this.getNowFormatDate(new Date());
                }
              } catch (e) {
                console.log(e);
              }
              if (item.RePayStatus === 1) {
                item.canRePay = true;
              }
              if (item.ReUploadStatus === 1) {
                item.canReUpload = true;
              }
              if (!item.canRePay && !item.canReUpload && !item.ViolationId && item.writ_notice_num && !item.Urge && nowhours > 8 && nowhours < 19) {
                // 罚单 处理中  无需补缴补图  9点以后，19点之前可以加急
                item.canUrge = true;
              }
            }
            // if (item.CommentStars) {
            //   item.CommentStarsObj = this.getCommentStarsObj(item.CommentStars)
            // }
            if (item.Urge) {
              // 有则为手动加急 无则正常下单加急自己算 。。。。。
              item.UrgeFee = item.UrgeFee || (item.TotalPrice - item.Fine - item.OwnFree - item.own_late_free + item.ReduceFree);
            }
            if (item.Urge && item.HandUrgeStatus) {
              item.TotalPrice += Number(item.UrgeFee);
            }
            if(item.RePayStatus===2){
              item.RePayFee = ((item.RePayFee || 0) / 100).toFixed(2)
            }
            return item;
          });
          this.lists = list;
        } else {
          this.lists = [];
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    getNowFormatDate(date) {
      const seperator1 = '-';
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = `0${strDate}`;
      }
      const currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    handleModify(item, mode) {
      this.$store.commit('SET_ORDER_MODIFY', item);
      console.log(mode, item, 'itemitemitem');
      this.$router.push({
        name: 'orderModify',
        query: {
          mode,
        },
      });
    },

  },
};
</script>
<style lang="scss" scoped>
.s4s-tab {
  height: 45px;
  background: #fff;
  font-size: 13px;
  line-height: 42px;
  display: flex;
  border-radius: 7px 7px 0 0;
  justify-content: space-between;
  padding: 0 10px;
}
.s4s-tab-cur {
  border-bottom: 3px #3A82FF solid;
  color: #24252d;
  font-weight: bold;
}
.s4s-tab-item {
  margin: 0 5px;
  line-height: 50px;
  font-size: 16px;
  text-align: center;
  color: #5b5e6a;
  position: relative;
  display: flex;
  align-items: center;
}
.s4s-order-body {
  margin: 10px;
}
.s4s-cell {
  margin-bottom: 10px;
  font-size: 14px;
  padding: 0 15px;
  background: #FFFFFF;
  box-shadow: 0 2px 4px 0 #EFEFEF;
  border-radius: 2px;
}
.s4s-cell-hd {
  display: flex;
  border-bottom: .5px #eaeaea solid;
  padding: 10px 0;
  align-items: center;
}
.s4s-cell-hd-time {
  flex: 1;
  color: #9c9ea8;
  font-size: 12px;
}
.s4s-cell-bd {
  padding-top: 15px;
  display: flex;
  align-items: center;
}
.s4s-cell-tit {
  color: #5b5e6a;
  margin-right:10px;
}
.s4s-cell-txt {
  color: #000000;
}

.s4s-cell-fd {
  border-top: .5px #eaeaea solid;
  padding: 15px 0;
  display: flex;
  justify-content: flex-end;
  user-select: none;
}
.s4s-cell-fd span,a {
  border-radius: 2px;
  padding: 5px 10px;
  margin-left: 8px;
  line-height: 17px;
  display: flex;
  align-items: center;
}
.s4s-cell-fd span:first-child,a  {
  border: .5px  #eaeaea solid;
  color: #9c9ea8;
  background: #fff;
  box-shadow: none;
}
.s4s-cell-fd span:last-child, .s4s-cell-fd span.opt-btn  {
  background-image: linear-gradient(-135deg, #115FF8 0%, #3A82FF 100%);
  box-shadow: 1px .1px 3px 0 #D2D2D2;
  color: #FFFFFF;
  border: none;
}
.s4s-cell-status {
  font-size: 13px;
  line-height: 14px;
  padding:.1px 0;
  border-radius: 2px;
}

.s4s-tab-num {
  text-align: center;
  background: #FD2900;
  display: inline-block;
  border-radius: 200px;
  color: #fff;
  box-sizing: content-box;
  font-size: 12px;
  line-height: 15px;
  position: absolute;
  right: -15px;
  top: 10px;
  padding: .1px 4px;
  min-width: 10px;
}

.wxpay-btn{
  color:#fff;
  background: #6BBB30; /* For browsers that do not support gradients */
  background: linear-gradient(-133deg, #6BBB30 0%, #3CB034 100%);
}
.alipay-btn{
  background: 60A3FF; /* For browsers that do not support gradients */
  background: linear-gradient(-133deg, #60A3FF 0%, #4F7EFF 100%);
}
</style>

